import React, { Component } from 'react'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

import './index.scss'

class Qliksaascharges extends Component {

    constructor(props) {
        super(props)
        this.mobileWidth = 0
        this.state = {
            width: window.innerWidth
        }
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    }

    render() {
        const url = "https://qlik.unifi.id/external-ticket-authentication/single/?appid=3d11637e-aa1b-464d-97f4-9de2776a8b33&sheet=b20526f0-9812-4d1f-9714-2657edc426b8&opt=currsel%2Cctxmenu&select=clearall"
        return (
            <PageContainer>
                <iframe src={url} />
            </PageContainer>
        )
    }
}

export default userIsAuthenticatedRedir(Qliksaascharges)



// WEBPACK FOOTER //
// ./src/pages/qliksaascharges/index.js